// extracted by mini-css-extract-plugin
module.exports = {"tn3hsof":"tn3hsof","t1pva50s":"t1pva50s","active":"active"};